import { useContext } from "react";
import { AdminAppContext } from "@/core/admin_app_context";

export type { AdminAppContextValue } from "@/core/admin_app_context";

export function useAdminApp() {
  const ctx = useContext(AdminAppContext);
  if (!ctx) throw new Error("useAdminApp must be used within AdminAppProvider");
  return ctx;
}
